module.exports = __webpack_public_path__ + "img/av.f14be36e.jpg";